import React from "react";
import { Users } from "lucide-react";
import EditRoleButton from "./EditRoleButton";
import { useRoleContext } from "../../../../context/RolesContext";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store";

const RoleHeader: React.FC = () => {
  const {
    activeName,
    isActiveRoleCustom,
    teamMembersCount,
    teamMembersText,
    teamMemberNames,
    subLoading,
  } = useRoleContext();

  const merchant = useSelector(
    (state: RootState) => state?.merchant?.permissions
  ) as string[] | undefined;

  const hasPermission = (permission: string): boolean => {
    return Array.isArray(merchant) && merchant.includes(permission);
  };

  const canUpdateRole = hasPermission("CAN_UPDATE_ROLE");

  return (
    <div className="bg-white p-6 rounded-lg shadow-sm border">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div>
          <div className="flex items-center gap-2 mb-1">
            <h2 className="text-xl font-semibold text-gray-800">
              {activeName}
            </h2>
            {isActiveRoleCustom && (
              <span className="px-2 py-0.5 text-xs font-medium bg-gray-100 text-gray-600 rounded-full">
                Custom
              </span>
            )}
          </div>
          <div className="flex items-center text-sm text-gray-600">
            <Users size={16} className="mr-2" />
            {subLoading ? (
              "Loading team members..."
            ) : teamMembersCount > 0 ? (
              <>
                {teamMembersCount} {teamMembersText}: {teamMemberNames}
              </>
            ) : (
              <>No team members with this role</>
            )}
          </div>
        </div>

        {isActiveRoleCustom && canUpdateRole && <EditRoleButton />}
      </div>
    </div>
  );
};

export default RoleHeader;
